function addClass(element, className) {
    element.classList.add(className);
}

function removeClass(element, className) {
    element.classList.remove(className);
}

// Read More Functions
document.addEventListener("DOMContentLoaded", () => {
    let readMoreBtns = document.getElementsByClassName('read-more__btn');
    let readLessBtns = document.getElementsByClassName('read-less__btn');

    for (let btn of readMoreBtns) {
        btn.addEventListener('click', () => {
            openReadMore(btn);
        })
    }

    for (let btn of readLessBtns) {
        btn.addEventListener('click', () => {
            closeReadLess(btn);
        })
    }
})

function openReadMore(btn) {
    btn.classList.add('hidden');
    btn.parentElement.nextElementSibling.classList.remove('hidden')
}

function closeReadLess(btn) {
    btn.parentElement.previousElementSibling.querySelector('span.hidden').classList.remove('hidden');
    btn.parentElement.classList.add('hidden');
}

// Play Video Functions
document.addEventListener("DOMContentLoaded", () => {
    let videos = document.getElementsByClassName('play-btn-click');

    for (let video of videos) {
        video.addEventListener('click', () => {
            playVideo(video);
        })
    }
})

function playVideo(btn) {
    let videoLink = btn.dataset.video
    if (videoLink.includes("youtube")) {
        let videoId = '';
        if (videoLink.includes('/shorts/')) {
            videoId = videoLink.split('https://www.youtube.com/shorts/')[1];
        } else {
            videoId = videoLink.split('https://www.youtube.com/watch?v=')[1];
        }

        let video = `
            <div id='video-container' class='video__bg' onclick='closeVideo()'>
                <div class='video__container'>
                    <div class='close__video'>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17" onclick='closeVideo()'>
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                        </svg>
                    </div>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        `;

        document.body.insertAdjacentHTML("afterbegin", video);
        console.log(videoId)
    } else {
        let video = `
            <div id='video-container' class='video__bg' onclick='closeVideo()'>
                <div class='video__container'>
                    <div class='close__video'>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17" onclick='closeVideo()'>
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                        </svg>
                    </div>
                    <video class='video-player' autoplay muted controls>
                        <source src="${videoLink}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        `;

        document.body.insertAdjacentHTML("afterbegin", video);
        console.log(videoLink)
    }

}

function closeVideo() {
    let video = document.getElementById('video-container')
    video.remove();
}

// Scroll Function
function scrollTo(containerClass, elementIndex) {
    let container = document.querySelector(`${containerClass}`);
    let childElements = container.children;
    let childElementLengthIndexed = childElements.length - 1;
    elementIndex = (elementIndex < 0) ? 0 : ((elementIndex > childElementLengthIndexed) ? childElementLengthIndexed : elementIndex);

    childElements[elementIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

// Scroll Functions For Arrow.liquid Snippet
function scrollArrow(button) {
    // initiate values
    let current = parseInt(button.dataset.index);
    let limit = parseInt(button.dataset.limit);
    let direction = button.dataset.direction;
    let containerClass = button.dataset.containerClass;
    let step = parseInt(button.dataset.stepMobile);

    // change step based on the window size
    let windowSize = window.innerWidth;
    if (windowSize >= 992) {
        step = parseInt(button.dataset.stepDesktop);
    } else if (windowSize >= 768 && windowSize < 992) {
        step = parseInt(button.dataset.stepTablet);
    }

    let next = 0;
    if (direction == "right") {
        next = (current + step >= limit) ? limit : current + step;
        if (current % step == 0) {
            next = current + step + (step - 1);
            next = (next >= limit) ? limit : next;
        }
    } else {
        next = (current - step <= 0) ? 0 : current - step;
        if (current % step == 0) {
            next = current - step - (step - 1);
            next = (next <= 0) ? 0 : next;
        }
    }

    if (current == limit || current == 0) {
        if (direction == "right") {
            next = current + step + (step - 1);
            next = (next >= limit) ? limit : next;
        } else {
            next = current - step - (step - 1);
            next = (next <= 0) ? 0 : next;
        }
    }

    scrollTo(containerClass, next); // scroll to element
    updateArrowsIndex(containerClass, next); // update arrows index value
    disabelArrows(containerClass); // disable arrows
    enableArrows(containerClass); // enable arrow

    // update dots information
    let reference = (direction == "right") ? Math.floor(next / step) : Math.ceil(next / step);
    updateDots(containerClass, reference, next);
}

function updateArrowsIndex(containerClass, value) {
    let parentContainer = document.querySelector(`${containerClass}`).parentElement;
    let arrows = parentContainer.querySelectorAll(`.arrow-container > .scroll-arrow`)
    for (let arrow of arrows) {
        arrow.dataset.index = value;
    }
}

function disabelArrows(containerClass) {
    let parentContainer = document.querySelector(`${containerClass}`).parentElement;
    let arrows = parentContainer.querySelectorAll(`.arrow-container > .scroll-arrow`)

    for (let arrow of arrows) {
        let arrowIndex = parseInt(arrow.dataset.index);
        let arrowLimit = parseInt(arrow.dataset.limit);

        if (arrow.dataset.direction == "right") {
            if (arrowIndex >= arrowLimit) {
                arrow.classList.add("disabled");
            }
        } else {
            if (arrowIndex <= 0) {
                arrow.classList.add("disabled");
            }
        }
    }
}

function enableArrows(containerClass) {
    let parentContainer = document.querySelector(`${containerClass}`).parentElement;
    let arrows = parentContainer.querySelectorAll(`.arrow-container > .scroll-arrow`)

    for (let arrow of arrows) {
        let arrowIndex = parseInt(arrow.dataset.index);
        let arrowLimit = parseInt(arrow.dataset.limit);

        if (arrow.dataset.direction == "right") {
            if (arrowIndex < arrowLimit) {
                arrow.classList.remove("disabled");
            }
        } else {
            if (arrowIndex > 0) {
                arrow.classList.remove("disabled");
            }
        }
    }
}

function updateDots(containerClass, reference, next) {
    let dots = document.querySelectorAll(`${containerClass} ~ .dot-container .dot-icon`)
    if (dots.length != 0) {
        updateDotIndex(containerClass, next);
        updateDotActive(containerClass, reference);
        removeDotSelectedClass(containerClass);
        addDotSelectedClass(containerClass, reference);
    }
}

// Scroll Functions For Dots.liquid Snippet
function scrollDots(button) {
    // initiate variables
    let limit = parseInt(button.dataset.limit);
    let current = parseInt(button.dataset.index);
    let reference = parseInt(button.dataset.reference);
    let active = parseInt(button.dataset.active);
    let containerClass = button.dataset.containerClass;
    let step = parseInt(button.dataset.step);
    let next = current;
    let isFirst = button.dataset.first;
    let isLast = button.dataset.last;

    // calculate next based on the reference position
    if (active < reference) {
        let dif = reference - active;
        next = (current + (step * dif));
        if (current % step == 0 || current == limit || current == 0) {
            next = current + (step * dif) + (step - 1);
        }
        next = (next >= limit) ? limit : next;
    } else if (active > reference) {
        let dif = active - reference;
        next = (current - (step * dif));
        if (current % step == 0 || current == limit || current == 0) {
            next = current - (step * dif) - (step - 1);
        }
        next = (next <= 0) ? 0 : next;
    }

    // if it's first dot, update next to 0
    if (isFirst) {
        next = 0;
    }
    // if it's last dot, update net to the limit;
    if (isLast) {
        next = limit;
    }

    scrollTo(containerClass, next); // scroll to next element
    updateDotIndex(containerClass, next); // update dots index information
    updateDotActive(containerClass, reference); // update dots active value
    removeDotSelectedClass(containerClass); // remove active class from all the dots
    addDotSelectedClass(containerClass, reference); // add active class to active dots
    updateArrows(containerClass, next); // if there are arrow, update arrows
}

function removeDotSelectedClass(containerClass) {
    let buttons = document.querySelectorAll(`${containerClass} ~ .dot-container .selected`);
    for (let button of buttons) {
        button.classList.remove("selected");
    }
}

function addDotSelectedClass(containerClass, reference) {
    let buttons = document.querySelectorAll(`${containerClass} ~ .dot-container [data-reference="${reference}"]`);
    for (let button of buttons) {
        button.classList.add("selected");
    }
}

function updateDotIndex(containerClass, index) {
    let dotButtons = document.querySelectorAll(`${containerClass} ~ .dot-container .dot-icon`);
    for (let dot of dotButtons) {
        dot.dataset.index = index;
    }
}

function updateDotActive(containerClass, active) {
    let dotButtons = document.querySelectorAll(`${containerClass} ~ .dot-container .dot-icon`);
    for (let dot of dotButtons) {
        dot.dataset.active = active;
    }
}

function updateArrows(containerClass, index) {
    let arrows = document.querySelectorAll(`${containerClass} ~ .arrow-container > .scroll-arrow`)
    if (arrows.length != 0) {
        for (let arrow of arrows) {
            updateArrowsIndex(containerClass, index)
        }
        disabelArrows(containerClass);
        enableArrows(containerClass);
    }
}
